
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

import { ProgressCircle } from 'vue-progress-circle'
import initialsHelper from '@/helpers/cardInfoHelperFunctions/initialsHelper';
import { hslColorFromName } from "@/utils/hslColorFromName";

@Component({
    components: {
        ProgressCircle
    },
})
export default class CircleProgressItem extends Vue {
    @Prop({ type: Object, default: null }) readonly item!: any;
    @Prop({ type: String, default: "" }) readonly color!: string;
    @Prop({ type: Number, default: 0 }) readonly completed!: number;
    @Prop({ type: Number, default: 0 }) readonly total!: number;
    @Prop({ type: Boolean, default: false }) readonly hasData!: boolean;

    get bgStyle(): string {
        return hslColorFromName(this.initial);

    }
    get initial(): string {
        return initialsHelper(this?.item?.title ? this.item.title : this.item.name);
    }

}
